import { PlateEditor, TText, Value } from '@udecode/plate-common';

import { ELEMENT_INTERLINK, MyInterlinkElement } from '../../../plateTypes';

export interface CreateInterlinkNodeOptions {
  linkId: string;
  linkTitle: string;
  langId: string | undefined;
  text?: string;
  children?: TText[];
}

export const createInterlinkNode = <V extends Value>(
  editor: PlateEditor<V>,
  {
    linkId,
    text = '',
    linkTitle,
    langId,
    children,
  }: CreateInterlinkNodeOptions,
): MyInterlinkElement => {
  return {
    type: ELEMENT_INTERLINK,
    linkId,
    linkTitle,
    langId,
    children: children ?? [{ text }],
  };
};
